import { render, staticRenderFns } from "./RegimenInfo.vue?vue&type=template&id=35ce187a&scoped=true"
import script from "./RegimenInfo.vue?vue&type=script&lang=js"
export * from "./RegimenInfo.vue?vue&type=script&lang=js"
import style0 from "./RegimenInfo.vue?vue&type=style&index=0&id=35ce187a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ce187a",
  null
  
)

export default component.exports